import RecordsTable from '../records-table';
import handleLoadingAndError from '../handle-loading-and-error';

const RecordsOverall = props => (
	<RecordsTable data={props.data} isMonthly={false} />
);

export default handleLoadingAndError(RecordsOverall);



// WEBPACK FOOTER //
// ./components/records-overall/index.js